import AiToolPanel from "@/components/ai/AiToolPanel";

const examples = [
  { label: "SaaS landing", value: "Landing page for a privacy-focused team chat app for remote engineering teams. Audience: CTOs and engineering managers." },
  { label: "Local service", value: "Orlando wedding photographer offering full-day coverage and same-week sneak peeks." },
  { label: "Blog post", value: "Blog post: 'How to debounce React inputs without losing keystrokes' — for intermediate React devs." },
];

const SeoMetaGenerator = () => (
  <AiToolPanel
    task="seo-meta"
    inputLabel="Describe the page"
    placeholder="What is the page about? Who is it for? Any keywords or brand voice notes?"
    buttonLabel="Generate SEO meta"
    rows={6}
    examples={examples}
  />
);

export default SeoMetaGenerator;